<template>
    <div>
      <h1>User Invoices</h1>
      <div v-if="invoices.length === 0">
        <p>No invoices found.</p>
      </div>
      <div v-else>
        <ul>
          <li v-for="invoice in invoices" :key="invoice.id">
            <p>Invoice Number: {{ invoice.invoiceNumber }}</p>
            <p>Amount: {{ invoice.amount }}</p>
            <!-- Add more details as needed -->
          </li>
        </ul>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'Invoices',
    computed: {
      invoices() {
        return this.$store.state.user.invoices;
      }
    }
  };
  </script>

  <style scoped>
  /* Your component-specific styles */
  </style>
